import React, { useContext, useEffect } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import ErrorBoundary from '../../../../Components/CustomErrorBoundary/CustomErrorBoundary';
import UpdateReactJson from '../../../../Components/UpdateReactJson';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';
import { AB_SPLIT_TEST_CONSTANTS, CONFIG_KEYDATA_CONSTANTS } from '../../../../core/constants';
//mui imports====
import useCommonStyles from '../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { Grid, Paper } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
//===============

const { PAGEVIEW_PREFIX, SEC_PV_TARGETING, DEFAULT_PV } = CONFIG_KEYDATA_CONSTANTS;

const CustomTargeting = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const targetingObj = rawConfig[keyData + '.targeting'] || {};
	const abSplitTestValue = targetingObj[AB_SPLIT_TEST_CONSTANTS.CUSTOM_TARGETING.KEY];
	const isPvTargetingEnabled = rawConfig[keyData + '.pageviewTargeting.enabled'];

	useEffect(() => {
		/**
		 * We're assigning the PV values automatically when pageview targeting is enabled
		 */
		if (isPvTargetingEnabled) {
			assignPvTargetingValue();
		}
		
	}, [isPvTargetingEnabled, abSplitTestValue, keyData]);


	/**
	 * This function assigns the PV targeting value to it's designated object in raw config
	 * based on conditions if ab_split_test value is present (it uses the value with a trailing _pv)
	 * or not (it initialises it as an empty string).
	 */
	const assignPvTargetingValue = () => {
		const targetingObj = rawConfig[keyData + '.targeting'] || {};
		const abSplitTestValue = targetingObj[AB_SPLIT_TEST_CONSTANTS.CUSTOM_TARGETING.KEY];
		const clonedObj = structuredClone(rawConfig);

		if (abSplitTestValue) {
			clonedObj[keyData + `.pageviewTargeting.${SEC_PV_TARGETING}`] =
				abSplitTestValue + PAGEVIEW_PREFIX;
		} else {
			clonedObj[keyData + `.pageviewTargeting.${SEC_PV_TARGETING}`] = DEFAULT_PV;
		}
		updateRawConfig(clonedObj);
	};

	/**
	 * Updates the PV targeting value in rawConfig
	 */
	const updatePvTargetingValue = (targetingValue) => {
		const clonedObj = structuredClone(rawConfig);
		clonedObj[keyData + `.pageviewTargeting.${SEC_PV_TARGETING}`] = targetingValue;
		updateRawConfig(clonedObj);
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Custom Targeting"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Custom Targeting']}
				description="Manage Custom Targeting Configuration for video section"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>

			<Typography
				className={commonStyleClasses.heading}
				fontWeight={300}
				variant="h4"
				style={{ width: 'fit-content', marginLeft: '5rem', marginTop: '5rem' }}
			>
				Targeting
			</Typography>
			<Grid
				container
				spacing={2}
				className={commonStyleClasses.gridStyles}
				style={{ width: '90%', marginLeft: '2rem' }}
			>
				<Grid item xs={12} style={{ border: '1px solid darkgrey', borderRadius: '4px' }}>
					<ErrorBoundary>
						<UpdateReactJson
							keyData={keyData + '.targeting'}
							object={rawConfig}
							updateObject={updateRawConfig}
							allowOnlyString={true}
						/>
					</ErrorBoundary>
				</Grid>
			</Grid>
			<Grid
				container
				spacing={0}
				style={{ marginTop: '5rem', marginLeft: '5rem', marginBottom: '4rem', width: '90%' }}
			>
				<Grid item xs={12}>
					<Typography
						className={commonStyleClasses.heading}
						fontWeight={300}
						variant="h4"
						style={{ width: 'fit-content', marginBottom: '4rem' }}
					>
						Pageview Targeting
					</Typography>
				</Grid>
				<Grid item xs={3}>
					<CheckBoxInput
						keyData={keyData + '.pageviewTargeting.enabled'}
						label="Enabled"
						disabled={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ margin: '4rem 0' }}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						editable={false}
						inputStyles={{ width: '100%', margin: '1rem 0' }}
						isObjectEditor={false}
						directValue={SEC_PV_TARGETING}
						label={'Key'}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						editable={!!rawConfig[keyData + '.pageviewTargeting.enabled']}
						inputStyles={{ width: '100%', margin: '1rem 0' }}
						isObjectEditor={false}
						directValue={rawConfig[keyData + `.pageviewTargeting.${SEC_PV_TARGETING}`]}
						updateDirectValue={(value) => {
							updatePvTargetingValue(value);
						}}
						placeholder="Enter value here"
						label={'Value'}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default CustomTargeting;
